<ng-progress class="c-app__progress"></ng-progress>

<router-outlet></router-outlet>


